import React, { useCallback, useEffect, useState } from "react";
import { HeadingTitle } from "../ModalContainer";
import DataTable from "../../DataTable/DataTable";
import axios from "axios";
import { toast } from "react-toastify";
import NoData from "../../Pagination/NoData";
import { BASEURI } from "../../../Middleware/axiosInstance";

const ViewCADMarker = (props) => {
  const { close } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const baseDomain = BASEURI.split("/")[0] + "//" + BASEURI.split("/")[2];

  const fetchCadData = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        `${baseDomain}/ManufactureOrders/ajaxUploadCadMarker/${props.cut_id}`
      );

      if (data.status === 1) {
        setData(data.manufacture_order_cut_cad_markers);
        setLoading(false);
      } else {
        setLoading(false);
        toast.error(data.msg);
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  }, [props.cut_id, baseDomain]);

  useEffect(() => {
    fetchCadData();
  }, [fetchCadData]);

  return (
    <>
      <HeadingTitle colorRed={false} title={props.title} closeModal={close} />
      <div
        style={{ maxHeight: "350px", overflow: "auto", position: "relative" }}
      >
        {data && data?.length > 0 ? (
          <DataTable
            header={["Estimated Weight", "Created On", "CAD File"]}
            viewcad={data}
            isLoading={loading}
          />
        ) : (
          <NoData />
        )}
      </div>
    </>
  );
};

export default ViewCADMarker;
